import axiosClient from './axiosClient';

const SurveyApi = {
  list: (data) => axiosClient.post('/api/period/list', data),

  create: (data) => axiosClient.post('/api/period/create', data),

  update: (data) => axiosClient.post('/api/period/update', data),

  delete: (id) => axiosClient.post('/api/period/delete', { id }),

  getDropdown: (data = {}) => {
    return axiosClient.post('/api/period/dropdown', data);
  },

  view: (id) => axiosClient.post('/api/period/view', { id }),

  getSurveyPeriods: (data) => axiosClient.post('/api/period/list', data),
};

export default SurveyApi;
